import { Config as NewsConfig } from "./news/news.config";
import { Config as DashboardConfig } from "./dashboard/dashboard.config";
import { Config as OnboardingConfig } from "./onboarding/onboarding.config";
import { Config as KnowledgeBaseConfig } from "./knowledgeBase/knowledgeBase.config";
import { Config as VideoPlayerConfig } from "./videoPlayer/videoPlayer.config";
import { Config as NotificationsConfig } from "./notifications/notifications.config";
import { Config as CompetenceConfig } from "./competence/competence.config";
import { Config as SurveysConfig } from "./surveys/surveys.config";
import { Config as TeamIndicatorsConfig } from "./teamIndicators/teamIndicators.config";
import { Config as ProfileConfig } from "./profile/profile.config";
import { Config as GamificationConfig } from "./gamification/gamification.config";
import { Config as CertificatesConfig } from "./certificates/certificates.config";
import { Config as ScrollLessonConfig } from "./scrollLesson/scrollLesson.config";
import { Config as AnonSurveyConfig } from "./anonSurvey/anonSurvey.config";
import { Config as TrainingsConfig } from "./trainings/trainings.config";
import { Config as FormConfig } from "./form/form.config";
import { Config as TrainingConfig } from "./training/training.config";
import { Config as IddConfig } from "./idd/idd.config";
import { Config as TrainingsV2Config } from "./trainingsV2/trainingsV2.config";
import { Config as TrainingV2Config } from "./trainingV2/trainingV2.config";
import { Config as KnowledgeBaseV2Config } from "./knowledgeBaseV2/knowledgeBaseV2.config";
import { Config as DashboardV2Config } from "./dashboardV2/dashboardV2.config";
import { Config as ProvisionsConfig } from "./provisions/provisions.config";
//<-- IMPORT MODULE CONFIG -->

export const Module = {
  News: NewsConfig,
  Dashboard: DashboardConfig,
  Onboarding: OnboardingConfig,
  KnowledgeBase: KnowledgeBaseConfig,
  VideoPlayer: VideoPlayerConfig,
  Notifications: NotificationsConfig,
  Competence: CompetenceConfig,
  Surveys: SurveysConfig,
  TeamIndicators: TeamIndicatorsConfig,
  Profile: ProfileConfig,
  Gamification: GamificationConfig,
  Certificates: CertificatesConfig,
  ScrollLesson: ScrollLessonConfig,
  AnonSurvey: AnonSurveyConfig,
  Trainings: TrainingsConfig,
  Form: FormConfig,
  Training: TrainingConfig,
  TrainingV2: TrainingV2Config,
  Idd: IddConfig,
  TrainingsV2: TrainingsV2Config,
  KnowledgeBaseV2: KnowledgeBaseV2Config,
  DashboardV2: DashboardV2Config,
  Provisions: ProvisionsConfig,
  //<-- INJECT MODULE CONFIG -->
};
